import { ErrorCode } from '@/errors/codes'

/**
 * Maps BFF `error_code` on 403 responses to a dedicated error route.
 * Backend codes use the `BACKEND_<digits>` prefix; keep cases in sync with the API StrEnum.
 */
export function dedicatedErrorCodeFromBackend403Payload(errorCode: unknown): ErrorCode | null {
  if (typeof errorCode !== 'string' || errorCode.length === 0) {
    return null
  }
  switch (errorCode) {
    case ErrorCode.NoCsrfHeader:
      return ErrorCode.NoCsrfHeader
    case ErrorCode.CsrfTokenMismatch:
      return ErrorCode.CsrfTokenMismatch
    case ErrorCode.PermissionDenied:
      return ErrorCode.PermissionDenied
    case ErrorCode.ClientsByIdsNoClientsFound:
      return ErrorCode.ClientsByIdsNoClientsFound
    default:
      return null
  }
}
